<template>
  <div class="vehicle-valuation">
    <div class="vehicle-valuation__header-group">
        <img class="vehicle-valuation__header-image" src="~@/assets/images/valuation-icon.png" alt="valuation-icon" />
        <p class="vehicle-valuation__header">{{header}}</p>
    </div>
    <div class="vehicle-valuation__container">
        <p class="vehicle-valuation__subheader">{{subheader}}</p>
        <div class="vehicle-valuation__price-group">
            <p class="vehicle-valuation__price-text">{{guidePriceText}}</p>
            <p class="vehicle-valuation__price">{{getValuationPrice()}}<span class="vehicle-valuation__asterisk">*</span></p>
        </div>
        <p class="vehicle-valuation__disclaimer"><span class="vehicle-valuation__asterisk">*</span>{{disclaimerText}}</p>
    </div>
  </div>
</template>

<script lang="ts">
import {
  Component, Prop, Vue
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const EnquiryModule = namespace('enquiryModule');

@Component
export default class CurrentVehicleValuationComponent extends Vue {
  @EnquiryModule.Getter public extraData;

  @Prop({ default: 'Current Vehicle Valuation' })
  public header!: string;

  @Prop({ default: 'From the valuation data provided, you could put this amount towards your next car...' })
  public subheader!: string;

  @Prop({ default: 'Your Guide Price' })
  public guidePriceText!: string;

  @Prop({ default: 'Based on market value, demand and seasonality. This valuation may not reflect the valuation shown by Motorway.' })
  public disclaimerText!: string;

  public getValuationPrice(): string {
    const guidePrice = this.extraData.find((x) => x.keyName === 'PartExchangeValue');

    if (guidePrice) {
      return `£${guidePrice.keyValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
    }

    return 'N/A';
  }
}
</script>
